import {
  STORAGE_KEYS,
  SECURITY_STORAGE_KEYS,
  INACTIVITY_OPTIONS,
  COLORS,
  SECURITY_COLORS,
  DEFAULT_ALERT_RADIUS_KM,
  MIN_ALERT_RADIUS_KM,
  MAX_ALERT_RADIUS_KM,
  APP_NAME,
  APP_DESCRIPTION,
  BRAND_TAGLINE,
} from '@shared/constants';

export {
  STORAGE_KEYS,
  SECURITY_STORAGE_KEYS,
  INACTIVITY_OPTIONS,
  COLORS,
  SECURITY_COLORS,
  DEFAULT_ALERT_RADIUS_KM,
  MIN_ALERT_RADIUS_KM,
  MAX_ALERT_RADIUS_KM,
  APP_NAME,
  APP_DESCRIPTION,
  BRAND_TAGLINE,
};

// API Configuration — uses relative path since frontend and backend are served from the same Render service
export const API_BASE_URL = typeof window !== 'undefined' && window.location.hostname === 'localhost'
  ? 'http://localhost:3001/api'
  : '/api';

// Firebase Config — reads from env vars (REACT_APP_FIREBASE_*).
// In production set the REACT_APP_FIREBASE_* env vars.
export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};
